// import React, { useState } from "react";
// import TreeIcon from "../../../public/tree-icon.svg";
// import { addAgent, signIn } from "../../../utils/apis/func";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';

// const AddAgent = () => {
//   const [loginData, setLoginData] = useState({
//     email: "",
//     dob: "",
//     firstName: "",
//     lastName: "",
//     phoneNumber: "",
//     address: "",
//     password: "",
//     profilePic: "",
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setLoginData({
//       ...loginData,
//       [name]: value,
//     });
//   };

//   const navigate = useNavigate();
//   const [isLoading, setisLoading] = useState(false);
//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     console.log(loginData);
//     setisLoading(true);
//     // dispatch(addisLoading(true));
//     const res: any = await addAgent(loginData);
//     console.log(res);
//     if (res?.status === 200 || res?.status === 201) {
//       toast('Agent Added Successfully', {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//         });
//       navigate("/agents");
//     }
//     // dispatch(addisLoading(false));
//     setisLoading(false);
//   };
//   return (
//     <>
//       <div className="px-3">
//         <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4 pr-8">
//           Add Agent
//         </p>
//       </div>
//       <main >
//         <form action="" onSubmit={

//           handleSubmit
//           }
//           className="flex flex-col  overflow-auto h-[100vh] gap-7 w-full lg:w-2/5 font-roboto text-sm font-normal leading-normal px-2 lg:px-6 mt-8"
//           >
//           <div className="bg-[#8E8E93] border h-[5vh] border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               First Name:{" "}
//               <input
//                 className="ml-4  flex-grow h-[4.7vh] bg-[#fff] rounded-lg px-1"
//                 type="text"
//                 id="firstName"
//                 name="firstName"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] border h-[5vh] border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Last Name:{" "}
//               <input
//                 className="ml-4  flex-grow h-[4.7vh] bg-[#fff] rounded-lg px-1"
//                 type="text"
//                 id="lastName"
//                 name="lastName"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Email:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="email"
//                 id="email"
//                 name="email"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Phone No:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="number"
//                 id="phone"
//                 name="phoneNumber"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Date Of Birth:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="date"
//                 id="date"
//                 name="dob"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Address:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="text"
//                 id="address"
//                 name="address"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Password:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="password"
//                 id="password"
//                 name="password"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="flex items-center justify-center">
//             {isLoading ? (
// <div className="text-center">
//   <div role="status">
//     <svg
//       aria-hidden="true"
//       className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
//       viewBox="0 0 100 101"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//         fill="currentColor"
//       />
//       <path
//         d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//         fill="currentFill"
//       />
//     </svg>
//     <span className="sr-only">Loading...</span>
//   </div>
// </div>
//             ) : (
//               <button
//                 type="submit"
//                 className="bg-[#88087B] sm:w-[100%] sm:h-[5vh] lg:w-[25vw]  px-5 text-[#FFCD1E] rounded-md  text-shadow-md font-roboto text-lg font-medium leading-normal"
//               >
//                 Done
//               </button>
//             )}
//           </div>
//         </form>
//       </main>
//     </>
//   );
// };

// export default AddAgent;

import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addAgent } from "../../../utils/apis/func";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Loader from "../../Loader";

const AddAgent = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const initialValues = {
    email: "",
    dob: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    address: "",
    password: "",
    profilePic: "",
    accountType: "admin",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    dob: Yup.string().required("Date of birth is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    phoneNumber: Yup.string().required("Phone number is required"),
    address: Yup.string().required("Address is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(16, "Password must be at most 16 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      ),
    accountType: Yup.string().required(),
  });

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    try {
      setisLoading(true);
      const res = await addAgent(values);
      if (res?.status === 200 || res?.status === 201) {
        toast("Agent Added Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error adding agent:", error);
    } finally {
      setisLoading(false);
    }
    setSubmitting(false);
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4 pr-8">
          Add Agent
        </p>
      </div>
      <main>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="flex flex-col overflow-auto h-[100vh] gap-7 w-full lg:w-2/5 font-roboto text-sm font-normal leading-normal px-2 lg:px-6 mt-8">
              <div className="bg-[#8E8E93] border h-[5vh] border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  First Name:{" "}
                  <Field
                    className="ml-4 flex-grow h-[4.7vh] bg-[#fff] rounded-lg px-1"
                    type="text"
                    id="firstName"
                    name="firstName"
                  />
                </p>
                <ErrorMessage
                  name="firstName"
                  component="div"
                  className="text-red-500"
                />
              </div>
              {/* Other form fields */}
              <div className="bg-[#8E8E93] border h-[5vh] border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Last Name:{" "}
                  <Field
                    className="ml-4 flex-grow h-[4.7vh] bg-[#fff] rounded-lg px-1"
                    type="text"
                    id="lastName"
                    name="lastName"
                  />
                </p>
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="text-red-500"
                />
              </div>
              <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Email:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="email"
                    id="email"
                    name="email"
                  />
                </p>
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500"
                />
              </div>
              <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Phone No:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                  />
                </p>
                <ErrorMessage
                  name="phoneNumber"
                  component="div"
                  className="text-red-500"
                />
              </div>
              <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Date Of Birth:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="date"
                    id="dob"
                    name="dob"
                  />
                </p>
                <ErrorMessage
                  name="dob"
                  component="div"
                  className="text-red-500"
                />
              </div>
              <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Address:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="address"
                    name="address"
                  />
                </p>
                <ErrorMessage
                  name="address"
                  component="div"
                  className="text-red-500"
                />
              </div>
              {/* <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Password:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="password"
                    id="password"
                    name="password"
                  />
                </p>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500"
                />
              </div> */}
              <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm relative">
                <p className="flex items-center">
                  Password:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prevState) => !prevState)}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 focus:outline-none"
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </button>
                </p>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500"
                />
              </div>

              <div className="flex items-center justify-center">
                {isSubmitting || isLoading ? (
                  <div className="text-center">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>

                
                ) : (
                  <button
                    type="submit"
                    className="bg-[#88087B] sm:w-[100%] sm:h-[5vh] lg:w-[25vw]  px-5 text-[#FFCD1E] rounded-md  text-shadow-md font-roboto text-lg font-medium leading-normal"
                  >
                    Done
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </main>
      {isLoading && <Loader />}
    </>
  );
};

export default AddAgent;
